import GraphqlJWT from "services/graphql-jwt";
import HelperDevelopment from 'utils/helper-development'

const HelperEncryption = {
	graphqlJWT: null,
	
	isJwtEnabled: () => {
		return !HelperDevelopment.isDev() && !HelperDevelopment.isTestWeb();;
	},
	
	/**
	 * Create the encryption class
	 * @returns null
	 */
	construct: () => {
		HelperEncryption.graphqlJWT = new GraphqlJWT( 'f0a940' );
	},

	createJWT: () => {
		if( HelperEncryption.graphqlJWT === null ) {
			HelperEncryption.construct();
		}
		
		return HelperEncryption.graphqlJWT;
	},

	getAlgorithm: () => {
		return HelperEncryption.createJWT().getAlgorithm();
	},

	resetKey: () => {
		HelperEncryption.createJWT().resetKey();
	},

	setKey: ( key ) => {
		HelperEncryption.createJWT().setKey( key );
	},

	encode: ( data ) => {
		return HelperEncryption.createJWT().encode( data );
	},

	decode: ( data ) => {
		return HelperEncryption.createJWT().decode( data );
	},
}

export default HelperEncryption
